export const DOCUMENTATION_LAST_REVIEWED = "2 September 2026";

export type HelpCategoryId =
  | "start"
  | "roles"
  | "workflows"
  | "administration"
  | "controls"
  | "imports"
  | "troubleshooting"
  | "security";

export type HelpIssue = {
  problem: string;
  resolution: string;
};

export type HelpArticle = {
  path: string;
  slug: string;
  category: HelpCategoryId;
  title: string;
  summary: string;
  metaTitle: string;
  metaDescription: string;
  audience: string[];
  prerequisites: string[];
  outcome: string;
  guidance: string[];
  evidence: string[];
  issues: HelpIssue[];
  related: string[];
  keywords: string[];
};

export type HelpCategory = {
  id: HelpCategoryId;
  label: string;
  title: string;
  description: string;
};

export type HelpManifestRecord = Pick<
  HelpArticle,
  "path" | "category" | "title" | "summary" | "audience" | "guidance" | "evidence" | "keywords"
>;
